import React from 'react';
import MUIDataTable from 'mui-datatables';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const customTheme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#e5f7f8',
          fontSize: '0.875rem',
          padding: '12px 10px',
          fontWeight: 'bold',
          textTransform: 'capitalize',
          color: 'black',
          fontFamily: 'poppins',
        },
        body: {
          borderBottom: '1px solid #b4b9c3',
          fontSize: '0.875rem',
          padding: '22px 10px',
        },
        footer: {
          padding: '12px 10px',
        },
      },
    },

    MuiTableFooter: {
      styleOverrides: {
        root: {
          backgroundColor: '#e5f7f8',
          padding: '12px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: '0.5rem',
        },
      },
    },
  },
});

const MyTable = ({ data, columns, title, options, filters, onFilterClick }) => {
  // Apply filters to data
  const applyFilters = (data, filters) => {
    if (!filters || !Array.isArray(filters) || filters.length === 0) {
      return data;
    }

    return data.filter((row) => {
      return filters.every(({ category, items }) => {
        if (!items || items.length === 0) return true;

        const value = row[category.toLowerCase().replace(' ', '_')];
        if (!value) return false;

        // Handle special cases
        if (category === 'Name') {
          const fullName = `${row.first_name} ${row.last_name}`.trim().toLowerCase();
          return items.some((item) => fullName.includes(item.toLowerCase()));
        }

        return items.some((item) => String(value).toLowerCase().includes(item.toLowerCase()));
      });
    });
  };

  const filteredData = filters ? applyFilters(data, filters) : data;

  return (
    <ThemeProvider theme={customTheme}>
      <MUIDataTable
        title={title || ' '}
        data={filteredData}
        columns={columns}
        options={{
          ...options,
          filter: false,
          filterType: 'none',
          search: false,
          download: true,
          print: true,
          viewColumns: true,
        }}
      />
    </ThemeProvider>
  );
};

export default MyTable;
